import $ from 'jquery';
import Dialog from 'ui/dialog';
import 'style-loader!./dropdown.css';

export default class Dropdown extends Dialog {

  constructor () {
    super();
    this.dialog.classList.add('d-dropdown');
  }

  showModal (target) {
    super.showModal();
    positionAtTarget(this.dialog, target);
  }

}

function positionAtTarget (element, target) {
  $(element).css('margin-left', 0).position({
    my: `left top+${$(target).height() / 2}px`,
    at: 'left buttom',
    of: target,
    collision: 'none'
  });
}
